import React from "react"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"

interface CancelDraftEventModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirmDiscard: () => void
  eventName?: string
}

/**
 * Modal for discarding event creation/draft
 * Simpler flow - just confirming loss of progress
 */
const CancelDraftEventModal: React.FC<CancelDraftEventModalProps> = ({
  isOpen,
  onClose,
  onConfirmDiscard,
  eventName,
}) => {
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]"
      onClick={handleOverlayClick}
    >
      <BlurWrapper
        overlayOpacityDefault="20"
        className="w-full max-w-sm mx-4 !bg-white/10 backdrop-blur-md rounded-2xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-8 text-center">
          {/* Title */}
          <h2 className="text-white text-2xl font-semibold mb-4">
            Are you sure you want to cancel this event?
          </h2>

          {/* Subtitle */}
          <p className="text-white/70 text-base mb-8 leading-relaxed">
            If you cancel now, all the progress you've made on this event will
            be lost.
          </p>
        </div>

        {/* Buttons */}
        <div className="border-t border-white/10 bg-[#252525B2] backdrop-blur-xl rounded-b-2xl">
          {/* Discard Button */}
          <button
            className="w-full py-4 text-red-400 font-medium border-b border-white/10 hover:bg-white/10 transition-colors"
            onClick={onConfirmDiscard}
          >
            Yes, Cancel
          </button>

          {/* Keep Editing Button */}
          <button
            className="w-full py-4 text-blue-400 font-medium hover:bg-white/10 transition-colors rounded-b-2xl"
            onClick={onClose}
          >
            Keep Editing
          </button>
        </div>
      </BlurWrapper>
    </div>
  )
}

export default CancelDraftEventModal
